<script>
    import LoginPage from "./pages/LoginPage.svelte";
    import PeoplePage from "./pages/PeoplePage.svelte";
    import CompaniesPage from "./pages/CompaniesPage.svelte";
    import ViewPersonPage from "./pages/ViewPersonPage.svelte";
    import AddPersonPage from "./pages/AddPersonPage.svelte";
    import QuickAddPage from "./pages/QuickAddPage.svelte";
    import PlannerPage from "./pages/PlannerPage.svelte";
    import AddCompanyPage from "./pages/AddCompanyPage.svelte";
    import DealsPage from "./pages/DealsPage.svelte";
    import AddDealPage from "./pages/AddDealPage.svelte";
    import ViewDealPage from "./pages/ViewDealPage.svelte";
    import PromotionsPage from "./pages/PromotionsPage.svelte";
    import AddPromotionPage from "./pages/AddPromotionPage.svelte";
    import ViewPromotionPage from "./pages/ViewPromotionPage.svelte";
    import DashboardPage from "./pages/DashboardPage.svelte";
    import RequestsPage from "./pages/RequestsPage.svelte";
    import ViewRequestPage from "./pages/ViewRequestPage.svelte";
    import AddRequestPage from "./pages/AddRequestPage.svelte";

    import Nav from "./Nav.svelte";

    import {people, setPeople} from "../stores/people.js";
    import {companies, setCompanies} from "../stores/companies.js";
    import {requests, setRequests} from "../stores/requests";
    import {deals, setDeals} from "../stores/deals";
    import {promotions, setPromotions} from "../stores/promotions";
    import {person_company, setPersonCompany} from "../stores/person_company.js";
    import {additional_people_info} from "../stores/misc.js";
    import ViewCompanyPage from "./pages/ViewCompanyPage.svelte";

    import FileUploader from "./FileUploader.svelte";
    import Lightbox from "./Lightbox.svelte";

    // ..do initial bootstrap loading of data
    (async () => {
        const response = await fetch(`/api/bootstrap-data`);
        let result = await response.json();
        setPeople(result.people);
        setCompanies(result.companies);
        setRequests(result.requests);
        setDeals(result.deals);
        setPromotions(result.promotions);
        setPersonCompany(result.person_company);
    })();

</script>

<Lightbox></Lightbox>

<FileUploader></FileUploader>

<Nav></Nav>

<LoginPage></LoginPage>

<DashboardPage></DashboardPage>

<PlannerPage></PlannerPage>

<PeoplePage></PeoplePage>
<ViewPersonPage></ViewPersonPage>
<AddPersonPage></AddPersonPage>

<RequestsPage></RequestsPage>
<ViewRequestPage></ViewRequestPage>
<AddRequestPage></AddRequestPage>

<CompaniesPage></CompaniesPage>
<ViewCompanyPage></ViewCompanyPage>
<AddCompanyPage></AddCompanyPage>

<DealsPage></DealsPage>
<AddDealPage></AddDealPage>
<ViewDealPage></ViewDealPage>

<PromotionsPage></PromotionsPage>
<AddPromotionPage></AddPromotionPage>
<ViewPromotionPage></ViewPromotionPage>

<QuickAddPage></QuickAddPage>

<!-- Some comments for getting tailwind to pick-up otherwise un-findable styles that we want present:
underline text-blue-600 hover:text-blue-800 visited:text-purple-600
-->

<style global lang="postcss">
    /* only apply purgecss on utilities, per Tailwind docs */
    /* purgecss start ignore */
    /* imports using postcss-import for FilePond CSS - must come first!! */
    @import 'filepond/dist/filepond.css';
    @import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
    @tailwind base;
    @tailwind components;
    @tailwind forms;
    /* purgecss end ignore */

    @tailwind utilities;
</style>